import { OverlayTrigger, Tooltip } from "react-bootstrap";

const EToolTip = (props) => {

    const { title, placement = "top", ...p } = props;

    const renderTooltip = (props) => (
        <Tooltip {...props}>{title}</Tooltip>
    );
    
     

    return (
        <OverlayTrigger placement={placement} overlay={renderTooltip}>
            <div>
            {props.children}
            </div>
        </OverlayTrigger>
    )
}

export default EToolTip;